const REQUEST_PLAYERS = '@@leaders/REQUEST_PLAYERS';
const PLAYERS_RESPONSE = '@@leaders/PLAYERS_RESPONSE';
const REQUEST_GOALIES = '@@leaders/REQUEST_GOALIES';
const GOALIES_RESPONSE = '@@leaders/GOALIES_RESPONSE';
const POINTS_LEADERS = '@@leaders/POINTS_LEADERS';
const GOALS_LEADERS = '@@leaders/GOALS_LEADERS';
const WINS_LEADERS = '@@leaders/WINS_LEADERS';
const GAA_LEADERS = '@@leaders/GAA_LEADERS';
const SET_SELECTED_GAME_TYPE = '@@leaders/SET_SELECTED_GAME_TYPE';

export default {
    REQUEST_PLAYERS,
    PLAYERS_RESPONSE,
    REQUEST_GOALIES,
    GOALIES_RESPONSE,
    POINTS_LEADERS,
    GOALS_LEADERS,
    WINS_LEADERS,
    GAA_LEADERS,
    SET_SELECTED_GAME_TYPE
};